const signatureJSONToSVGPaths = (signatureJSON, options = {}) => {
  try {
    options = Object.assign({
      offsetX: 0,
      offsetY: 0,
      width: 496,
      height: 270,
    }, options);
    let minX = 0;
    let minY = 0;
    let maxX = 0;
    let maxY = 0;
    const signature = JSON.parse(signatureJSON);
    signature.forEach(({ lx, ly, mx, my }) => {
      minX = Math.min(minX, lx, mx);
      minY = Math.min(minY, ly, my);
      maxX = Math.max(maxX, lx, mx);
      maxY = Math.max(maxY, ly, my);
    });
    let scale = Math.min(1, options.width / (maxX - minX), options.height / (maxY - minY));
    minX = Math.round(minX * scale) + options.offsetX;
    minY = Math.round(minY * scale) + options.offsetY;
    maxX = Math.round(maxX * scale) + options.offsetX;
    maxY = Math.round(maxY * scale) + options.offsetY;
    const paths = signature.map(({ lx, ly, mx, my }) => {
      return `M ${Math.round(mx * scale) + options.offsetX} ${Math.round(my * scale) + options.offsetY} L ${Math.round(lx * scale) + options.offsetX} ${Math.round(ly * scale) + options.offsetY}`;
    });
    return { minX, minY, maxX, maxY, paths };
  } catch(error) {
    console.error(`Cannot generate signature SVG paths, signatureJSON: ${signatureJSON}, error: ${error}`);
    return { minX: 0, minY: 0, maxX: 0, maxY: 0, paths: [] };
  }
};

export const signatureJSONToSVG = (signatureJSON, signatureStrokeColor = '#145394', signatureStrokeWidth = 2) => {
  try {
    const { minX, minY, maxX, maxY, paths } = signatureJSONToSVGPaths(signatureJSON);
    const dataUri = [
      `<svg viewBox="${minX} ${minY} ${maxX - minX} ${maxY - minY}" xmlns="http://www.w3.org/2000/svg">`,
      ...paths.map(d => `<path d="${d}" stroke="${signatureStrokeColor}" stroke-width="${signatureStrokeWidth}" />`),
      '</svg>'
    ];
    return `data:image/svg+xml,${encodeURIComponent(dataUri.join(''))}`;
  } catch(error) {
    console.error(`Cannot generate signature SVG, signatureJSON: ${signatureJSON}, error: ${error}`);
    return '';
  }
};